import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';

import routing from './yearly_active_report.routes';
import MonthlyActivePowerService from '../../../components/api/monthly_active_power/monthly_active_power.service';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import PowerFormatter from '../../../components/logic/power-formatter/power-formatter.logic';
import chartConfig from './yearly_active_report.config';

export class YearlyActiveReportController {
  /*@ngInject*/
  constructor($stateParams, $filter, $state, moment, PowerFormatter, DateUtil, MonthlyActivePowerService, CsvUtil) {
    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.moment = moment;
    this.PowerFormatter = PowerFormatter;
    this.MonthlyActivePowerService = MonthlyActivePowerService;

    this.downloadFileName = 'active_power.csv';

    this.chartConfig = chartConfig(this);
    this.sa = null;
  }

  $onInit() {
    this.updateGraph();
    this.parentComponent.saConfigPromise.then(res => {
      this.sa = res;
    });
  }

  updateGraph() {
    this.MonthlyActivePowerService.show({id: this.id}).$promise
      .then(response => {
        let powers = response.powers;
        let lastDate = powers.length > 0 ?
          this.moment(powers[powers.length - 1].billing_date).subtract(1, 'days')
          : this.moment();
        lastDate.startOf('month');

        // UI 表示用
        this.startDate = this.createStart(this.sa.billing_date);
        this.endDate = this.startDate.clone().add(12, 'months');

        this.categories = [];
        let start = this.createStart(this.sa.billing_date);

        for (let i = 0; i < 13; i++) {
          this.categories.push(start.valueOf());
          start.add(1, 'month');
        }

        this.chart.xAxis[0].update({
          categories: this.categories,
          max: 12
        });

        this.activePowerObjects = this.PowerFormatter.formatMonthlyActivePowers(powers, this.categories, this.sa.billing_date);
        this.activePowers = this.activePowerObjects.map(power => {return power.y});
        this.csvData = this.CsvUtil.processMonthlyActivePower(this.activePowers, this.categories);
        this.chart.series[0].setData(this.activePowerObjects);
        this.chart.reflow();

        this.downloadFileName = `active_power_${this.startDate.format('YYYY-MM')}_${this.endDate.format('YYYY-MM')}.csv`;
      });
  }

  createStart(configBillingDate) {
    const current = this.moment().startOf('month');
    if (configBillingDate === 1) {
      // 検針日が1日の場合、response.powersのbilling_dateが他の検針日のケースと異なり、必ず1ヶ月分先行する
      // グラフ表示の整合性を取るために、検針日に「99」を設定し後続の判定を回避させる
      configBillingDate = 99
    }

    if (this.moment().date() >= configBillingDate) {
      current.add(1, 'month');
    }

    return current.add(current.utcOffset(), 'minutes').utc().subtract(12, 'month');
  }
}

export default angular.module('leptonApp.yearlyActiveReport', [uiRouter, Chart, PowerFormatter, DateUtil, moment, MonthlyActivePowerService, CsvUtil])
  .config(routing)
  .component('yearlyActiveReport', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./yearly_active_report.html'),
    controller: YearlyActiveReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/active_report/yearly/yearly_active_report.component.js